import { ButtonGroup } from "@components/button";
import styled, { css } from "styled-components";

import { TextAlign } from "../../../../enums";
import { T_PLAIN_big, T_PLAIN_small, T_TITLE_4, T_TITLE_4_NORMAL } from "../../../../global.style";

export const StyledFormTableList = styled.div<{ $hasBackground: boolean }>`
    width: 100%;
    min-width: min-content;
    ${(props) => props.$hasBackground && css`
        background-color: ${props.theme.C_BG_hiddingpanel_new};
        padding: 37px;
        border-radius: 30px;
    `};
`;

export const Wrapper = styled.div<{
    $minWidth?: number;
    $columns?: number;
}>`
    max-width: 100%;
    display: inline-grid;
    grid-template-columns: ${({ $columns }) => $columns ? `repeat(${$columns}, auto)` : "auto auto"};
    gap: 12px 32px;
    align-items: center;
    ${({ $minWidth }) => $minWidth && css`
        min-width: ${$minWidth}px;
    `};

    @media (max-width: 600px) {
        grid-template-columns: auto;
    }
`;

export const SectionTitle = styled.div<{ $columns: number }>`
    ${T_TITLE_4};
    grid-column: span ${props => props.$columns};
    font-weight: bold;
    padding-top: 32px;
    text-transform: uppercase;

    display: flex;
    align-items: center;
    
    &:first-child {
        padding-top: 0;
    }

    span {
        margin-right: 10px;
    }
    &::after {
        content: " ";
        display: block;
        flex-grow: 1;
        height: 2px;
        background-color: ${({ theme }) => theme.C_BG_row_field};
    }
`;

export const Cell = styled.div<{
    $hasMark?: boolean;
    $woTopMargin?: boolean;
    $isBold?: boolean;
    $isSubRow?: boolean;
    $columns?: number;
    $align?: TextAlign
}>`
    ${T_TITLE_4_NORMAL};
    position: relative;
    align-self: end;
    
    ${({ $isSubRow, $align }) => $isSubRow && css`
        ${T_PLAIN_small};
        padding-left: ${$align === TextAlign.Left ? 12 : 0}px;
    `};
    
    ${({ $columns }) => $columns > 1 && css`
        grid-column: span ${$columns};
    `};
    
    ${({ $isBold }) => $isBold && css`
        font-weight: bold;
    `};
    
    ${({ $hasMark, theme }) => $hasMark && css`
        &::before {
            content: " ";
            position: absolute;
            top: 0; bottom: 0; left: -5px;
            width: 2px;
            background-color: ${theme.C_SEM_el_warning};
        }
    `};
    
    text-align: ${({ $align }) => $align === TextAlign.Left ? "left" : "right"};
`;

export const HeaderCell = styled(Cell)`
    ${Cell} + & {
        margin-top: ${props => props.$isSubRow || props.$woTopMargin ? 4 : 18}px;
    }
    ${SectionTitle} + & {
        margin-top: 7px;
    }
`;

export const EditDialogWrapper = styled(Wrapper)`
    grid-template-columns: auto auto 120px;
    
    ${SectionTitle} {
        grid-column: span 3;
    }
    
    ${Cell} {
        align-self: center;
    }
`;

export const ButtonGroupStyled = styled(ButtonGroup)`
    width: 100%;
    margin: 25px 10px 0 0;
`;

export const PlaceholderWrapper = styled.p`
    ${T_PLAIN_big}
`;
